export function getTextKeysAndPaths(pathname: string): [string[], string[]] {
  const breadcrumbItems = pathname.split("/").slice(1);
  let pathCurrentBreadcrumb = '';
  let textKeys = new Array<string>();
  let paths = new Array<string>();

  breadcrumbItems.forEach((element) => {
    pathCurrentBreadcrumb = `${pathCurrentBreadcrumb}/${element}`;

    if (!['node', 'section', 'structure'].includes(element)) {
      textKeys.push(element);
      paths.push(pathCurrentBreadcrumb);
    }
  });
  return [textKeys, paths]
};
